<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <!--右侧内容-->
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>试卷
    </div>
    <div class="class_add_con">
        <form data-vv-scope="form">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr class="tita">
              <td class="left_td">试卷信息</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td class="left_td pt30">试卷名称：</td>
              <td class="pt20">
                <input type="text" name="title" v-validate="'required'" v-model="params.title" placeholder="试卷名称" class="put_495" style=" width:395px;"/>
                <div class="error_msg_tip">{{ errors.first('form.title') }}</div>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">所属分类：</td>
              <td class="pt20">
                <select name="select" v-model="params.largeType" class="all_select" @change="getMiddleTypes(params.largeType)">
                  <option v-for='item in largeTypes' :key="item.value" :value="item.value">{{item.label}}</option>
                </select>
                <select name="select" v-model="params.middleType" class="all_select">
                  <option v-for='item in middleTypes' :key="item.middleType" :value="item.middleType">{{item.middleTypeLabel}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="left_td"></td>
              <td>
                <p>没有合适的分类？您可以<router-link :to="{path: prefix + '/org/examClassification_f/' + $utils.URLencode(this.$route.fullPath) + '/' + this.$route.params.id}" class="routerLink">添加新分类</router-link></p>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">难易度：</td>
              <td class="pt20">
                <select name="select" v-model="params.level" class="all_select">
                  <option v-for='item in Dropdown.state.level' :key="item.value" :value="item.value">{{item.label}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">试卷类型：</td>
              <td class="pt20">
                <select name="select" v-model="params.type" class="all_select">
                  <option v-for='item in Dropdown.state.examPaperType' :key="item.value" :value="item.value">{{item.label}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="left_td" valign="top">考卷封面：</td>
              <td valign="top" class="adjustImage rdiv">
                <img v-if="params.faceUri && params.faceUri!==''" :src="params.faceUri"  class="upload_img" />
                <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'faceUri'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
                <p class="mt10"><span class="tips_text">建议图片长280px宽150px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">总分：</td>
              <td class="pt20">
                <input type="text" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" v-validate="'required'" name="score" v-model="params.score" class="put_495" style=" width:140px;"/>
                <div class="error_msg_tip">{{ errors.first('form.score') }}</div>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">合格分数线：</td>
              <td class="pt20">
                <input type="text" onkeyup="this.value=this.value.replace(/[^\-?\d.]/g,'')" v-validate="'required'" name="passline" v-model="params.passline" class="put_495" style=" width:140px;"/>
                <div class="error_msg_tip">{{ errors.first('form.passline') }}</div>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">考试时长(分钟)：</td>
              <td class="pt20" ><input type="text" v-model="params.time" class="put_495" style=" width:140px;"></td>
            </tr>
            <tr>
              <td class="left_td pt30">是否免费：</td>
              <td class="pt20"><input name="money" type="radio" value="1" v-model="money" @change="changePrice('1')"/>
                是　　　
                <input name="money" type="radio" value="0" v-model="money" @change="changePrice('0')"/>
                否　　
                <label class="moneyLabel" v-if="money=='0'">　
                  <input name="price" type="text" v-validate="'positiveNumber'" class="put_num" v-model="params.point" />
                  元
                </label>
                <div class="error_msg_tip">{{ errors.first('form.price') }}</div>
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">重复考试：</td>
              <td class="pt20"><input name="canDuplication" type="radio" value="1" v-model="params.canDuplication"/>
                是　　　
                <input name="canDuplication" type="radio" value="0" v-model="params.canDuplication"/>
                否　　
              </td>
            </tr>
            <tr>
              <td class="left_td pt30">会员打折：</td>
              <td class="pt20"><input type="text" name="discount" v-model="params.discount" placeholder="请输入1-100的整数" class="put_495" style=" width:140px;"/> %</td>
            </tr>
            <tr>
              <td class="left_td pt30" valign="top">考试时间：</td>
              <td class="pt20">
                <input type="text" name="startDate" id="J-xl" placeholder="选择开始时间" v-model="params.startDate">
                <input type="text" name="endDate" id="J-xl-2" placeholder="选择结束时间" v-model="params.endDate">
              </td>
            </tr>
            <tr>
              <td class="left_td pt30" valign="top">试题选择：</td>
              <td class="pt30">
                <div>
                  <div style="display: inline-block;">
                    <a href="javascript:;" @click="addQuestion()"  class="add_bt_all">添加试题</a>
                  </div>
                  <div style="display: inline-block">共 {{currentQListLength}} 道题</div>
                </div>
                <div class="clear"></div>
                <table width="790" border="0" cellspacing="0" cellpadding="0" class="select_stlist">
                  <tr>
                    <th width="150">排序</th>
                    <th width="500">试题名称</th>
                    <th width="200">分值</th>
                    <th width="90">操作</th>
                  </tr>
                  <tr v-for="item in currentQList" :key="item.id">
                    <td><input type="text" class="put_495" style=" width:100px;" v-model="item.sort"/></td>
                    <td>{{item.title}}</td>
                    <td><input type="text" class="put_495" style=" width:100px;" v-model="item.score"/></td>
                    <td><a href="javascript:;" @click="delQ(item.id)">删除</a></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="left_td pt20" valign="top">试卷描述：</td>
              <td class="pt10"><textarea name="" cols="" rows="" v-model="params.description" class="text_area"></textarea></td>
            </tr>
            <tr class="tita">
              <td class="left_td">试卷设置</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td class="left_td">状态：</td>
              <td>
                <input name="state" type="radio" value="1" v-model="params.isPublish" /> 上架
                <input name="state" type="radio" value="0" v-model="params.isPublish" /> 下架
              </td>
            </tr>
            <tr>
              <td class="left_td " valign="top" style="padding-top:20px;">推送范围(显示到前台"任务"列表中)：</td>
              <td class="pt20" valign="top"><p >
                <input name="see" type="radio" value="2" v-model="params.visibleRange"/>
                全员　　
                <input name="see" type="radio" value="1" v-model="params.visibleRange"/>
                指定人员　
                <input name="see" type="radio" value="0" v-model="params.visibleRange"/>
                无</p>
                <!--指定人员-->
                <dl class="qa_man_add" v-if="params.visibleRange == '1'">
                  <dt><a href="javascript:void(0);" @click="showRange" class="on">+选择</a></dt>
                  <dd v-if="publicStateList.length > 0">
                    已选标签{{rangePermission.getPersonTypes(publicStateList).tags}}个,
                    已选用户{{rangePermission.getPersonTypes(publicStateList).users}}个,
                    已选人员{{rangePermission.getPersonTypes(publicStateList).members}}个,
                    已选部门{{rangePermission.getPersonTypes(publicStateList).depts}}个
                    <!--span v-for="item in publicStateList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span-->
                  </dd>
                </dl>
                <!--/指定人员--></td>
            </tr>
          </table>
          <p class="btn_center">
            <input type="button" class="all_btn" value="保存提交" @click="editExamPaper('form')"/>
          </p>
        </form>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

import {init} from '@/assets/js/public'
import Dropdown from '@/store/modules/dropdowns'
import UploadOSS from '@/components/common/upload/uploadOSS.vue'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import questionSelect from '@/page/byl/org/examination_question/select.vue'
import ModalBox from '@/components/common/modal/index.vue'
import rangeManip from '@/components/byl/rangeManip/index.vue'
import utils from '@/utils'
import rangePermission from '@/utils/rangePermission'
import Bus from '@/utils/bus'
import '@/utils/validator.js'
export default {
  components: { UploadOSS, questionSelect },
  data () {
    return {
      rangePermission:  rangePermission,
      Dropdown: Dropdown,
      params: {
        description: '',
        faceUri: '',
        isPublish: '0',
        isFree: '1',
        canDuplication: '1',
        largeType: '',
        level: '',
        middleType: '',
        passline: '',
        point: '0',
        score: '',
        time: '',
        title: '',
        type: '1',
        discount: '',
        visibleRange: '0',
        questionList: '',
        startDate: '',
        endDate: '',
        isUsed: '0'
      },
      money: '1',
      largeTypes: [],
      middleTypes: [],

      questionList: [],
      currentQList: [],
      currentQListLength: 0,

      publicStateList: [], // 权限范围
      prefix: this.$route.meta.prefix || '',
      uploadOSSConf: { showMode: '1', style: 'img_upload2', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
    }
  },
  created () {
    if (this.$route.params.id === 'create') {
      this.params = {
         description: '',
         faceUri: '',
         isFree: '1',
         isPublish: '0',
         canDuplication: '1',
         largeType: '',
         level: '',
         middleType: '',
         passline: '',
         point: '0',
         score: '',
         time: '',
         title: '',
         type: '1',
         discount: '',
         visibleRange: '0',
         questionList: '',
         isUsed: '0',
         startDate: '',
         endDate: ''
       }
       this.money = '1'
       this.questionList = []
    } else {
      this.getExamPaper(this.$route.params.id).then((r) => {
        rangePermission.getRange(this.$route.params.id, '01', this.params.visibleRange).then((r) => {  // 获取推送范围
          this.publicStateList = r
        })
      })
    }
    this.getLargeTypes()
  },
  mounted () {
    this.$nextTick(() => {
      this.initLayDate()
    })
    this.getSTS()
    Bus.$on('selectedQuestions', (data) => {
      this.currentQList = data
    })
  },
  computed: {
    isEdit () {
      return this.$route.params.id && this.$route.params.id !== 'create'
    }
  },
  watch: {
    'currentQList': {
      handler (newVal, oldVal) {
        if (newVal.length == 0) {
          this.params.score = 0
        } else {
          this.params.score = this.sumScore(this.currentQList)
        }
        this.currentQListLength = newVal.length
      },
      deep: true
    }
  },
  methods: {
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: '提交',
        text: '确认提交吗？',
        buttons: [
          {
            title: '确认',
            default: false,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    OSSUploadSuccess (r) {
      if (r && r != '') {
        this.$set(this.params, r.dom_id, r.res.requestUrls[0])
      }
    },
    changePrice (val) {
      this.params.point = '0'
      this.params.isFree= val
    },
    getLargeTypes () {
      this.$api.post(this.$global.examApiPath, '/dict/get', {type: 'examPaperLargeType'}, r => {
        this.largeTypes = r.data
      })
    },
    getMiddleTypes (largeType) {
      this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: largeType, middleType: 'examPaperMiddleType', select: '1'}, r => {
        this.middleTypes = r.data
      })
    },
    getExamPaper (id) {
      return new Promise((resolve, reject) => {
        this.$api.post(this.$global.examApiPath, '/examPaper/get', {id: id}, r => {
          resolve(r.data[0])
          this.params = r.data[0]
          this.getMiddleTypes(this.params.largeType)
          this.questionList = r.data[1]
          if (this.params.isFree == '1') {
            this.money = '1'
            this.params.point = '0'
          } else if (this.params.isFree == '0') {
            this.money = '0'
            this.params.point = parseFloat(this.params.point).toFixed(2)
          }
          for (let i=0; i<this.questionList.length; i++) {
            let temp = {
              id: this.questionList[i].questionId,
              title: this.questionList[i].questionTitle,
              score: this.questionList[i].score,
              sort: this.questionList[i].sort
            }
            this.currentQList.push(temp)
          }
        })
      })
    },
    examScoreIsValid (arr, data) {
      if (data.score == 0 || data.passline == 0) {
        return { value: false, msg: '考试总分/及格线不能为0'}
      } else {
        if (data.score < data.passline) { return { value: false, msg: '考试总分不能小于及格线' }}
        else if (this.sumScore(arr) == 0) { return { value: false, msg: '考卷试题总分不能为0' }}
        else { return { value: true }}
      }
    },
    sumScore (arr) {
      var result = 0;
      for (let i = 0; i < arr.length; i++) {
        let p = arr[i]
        if (p.score) {
          result += Number(p.score) // 计算总学分
        }
      }
      return result
    },
    editExamPaper (scope) {
      var self = this
      if (self.params.startDate=='' || self.params.endDate=='') {
        self.$toasted.show('请确保开始时间与结束时间不能为空！', {
          duration: 800
        })
      } else {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            if (self.currentQList.length == 0) {
              self.$toasted.show('请选择试题')
            } else {
              let o = self.examScoreIsValid(self.currentQList, self.params)
              if (o.value) {
                self.confirmBox({
                  yes: function () {
                    var tempQStr = ''
                    for (let i=0; i<self.currentQList.length; i++) {
                      if (!self.currentQList[i].score || self.currentQList[i].score=='') {
                        self.currentQList[i].score = 0
                      }
                      if (i<self.currentQList.length-1) {
                        tempQStr += self.currentQList[i].id + '|' + self.currentQList[i].score + ','
                      } else if (i==self.currentQList.length-1) {
                        tempQStr += self.currentQList[i].id + '|' + self.currentQList[i].score
                      }
                    }
                    self.params.questionList = tempQStr
                    self.$api.post(self.$global.examApiPath, '/examPaper/save', self.params, r => {
                      if (self.$route.params.id == 'create') {
                        self.$toasted.show('试卷创建成功！', {
                          duration: 1000
                        })
                        rangePermission.saveTo(r.data, '01', {type: self.params.visibleRange, value: self.publicStateList})
                        self.$router.push({path: self.prefix + '/org/examPaperList'})
                      } else {
                        self.$toasted.show('试卷修改成功！', {
                          duration: 1000
                        })
                        rangePermission.saveTo(self.params.id, '01', {type: self.params.visibleRange, value: self.publicStateList})
                        self.$router.push({path: self.prefix + '/org/examPaperList'})
                      }
                    })
                  }
                })
              } else {
                self.$toasted.show(o.msg)
              }
            }
          } else {
            self.$toasted.show('请确保信息正确与完整！', {
              duration: 800
            })
            return false
          }
        })
      }
    },
    addQuestion () {
      var that = this
      this.$modal.show(questionSelect, {
        qList: that.currentQList
      })
    },
    delQ (questionId) {
      for (let i=0; i<this.currentQList.length; i++) {
        if (this.currentQList[i].id == questionId) {
          this.currentQList.splice(i, 1)
        }
      }
    },
    getSTS () {
      this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
        let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
        this.uploadOSSConf.STS = STS
      })
    },
    initLayDate () {
      var self = this
      var startTime = laydate.render({
        elem: '#J-xl',
        type: 'datetime',
        done: function (value, date) {
          endTime.config.min ={
            year:date.year,
            month:date.month-1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds : 0
          };
          self.$set(self.params, 'startDate', value)
          self.params.startDate=value;
        }
      });
      var endTime = laydate.render({
        elem: '#J-xl-2',
        type: 'datetime',
        done: function (value, date) {
          startTime.config.max={
            year:date.year,
            month:date.month-1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds : 0
          }
          self.$set(self.params, 'endDate', value)
          // self.params.endDate=value;
        }
      });
    },
    showRange () {
      var that = this
      this.$modal.show(ModalBox, {
        opts: {
          title: '设置推送范围',
          styles: {
            width: '960',
            height: String(0.8242 * window.screen.availHeight)
          },
          currentComponent: {
            name: 'range',
            template: rangeManip,
            outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
            inputs: that.publicStateList // 向组件内传入的数据, 一般用于初始化
          },
          yes (val) { // 点击确认后要做的事情
            that.publicStateList = val
          },
          closed () { // 这里要判断, 只有新增状态下需要清空
            if (that.$route.params.id == 'void') {
              that.publicStateList = []
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_paper/model.vue